import { render, staticRenderFns } from "./manage-sso-mapping.vue?vue&type=template&id=0e6f2f2d&scoped=true"
import script from "./manage-sso-mapping.vue?vue&type=script&lang=js"
export * from "./manage-sso-mapping.vue?vue&type=script&lang=js"
import style0 from "./manage-sso-mapping.vue?vue&type=style&index=0&id=0e6f2f2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6f2f2d",
  null
  
)

export default component.exports